












































import {
	computed,
	defineComponent,
	onMounted,
	watchEffect,
} from '@vue/composition-api';
import { required } from '@front-app/components/form/validation/validators';
import { v } from '@front-app/components/form/validation/useValidation';
import { useHighlightsInput } from '@front-app/modules/group/highlights/hooks/useHighlightsInput';
import { UserAvatarStore, UserStore } from '@front-app/store/singletons/User';
import { UserSearchItem } from '@front-app/services/UserApi/UserModel';
import { SearchOption } from '@front-app/components/search/useSearch';
import { DropdownPosition } from '@front-app/components/dropdowns/dropdownPosition';
import { STATUS } from '@front-app/constants/state';
import FormSection from '@front-app/components/form/FormSection.vue';
import FormLabel from '@front-app/components/form/FormLabel.vue';
import FormError from '@front-app/components/form/FormError.vue';
import SelectedUserButton from '@front-app/components/buttons/SelectedUserButton.vue';
import SearchGroupUsers from '@front-app/components/inputs/SearchGroupUsers.vue';
import { BUTTON_EDITOR_PROPS } from './buttonEditor';
import BaseButtonEditor from './BaseButtonEditor.vue';

export default defineComponent({
	components: {
		BaseButtonEditor,
		FormSection,
		FormLabel,
		SelectedUserButton,
		SearchGroupUsers,
		FormError,
	},
	props: BUTTON_EDITOR_PROPS,
	setup(props, ctx) {
		const useInput = useHighlightsInput(ctx, computed(() => props.value));

		// Validation
		const validation = v({
			userId: {
				value: computed(() => props.value.meta.userId),
				rules: [required()],
			},
		});
		onMounted(() => {
			validation.validate();
		});

		// User search
		watchEffect(async () => {
			if (props.value.meta.userId) {
				UserStore.getInstance().fetch(props.value.meta.userId);
				UserAvatarStore.fetch(props.value.meta.userId);
			}
		});
		const handleUserSearchItemClicked = (user: SearchOption<UserSearchItem>): void => {
			UserStore.getInstance().setPartial({ ...user.original, status: STATUS.SUCCESS });
			useInput.doMetaInput({ userId: user.original.id });
			validation.validate();
		};
		const removeUser = (): void => {
			useInput.doMetaInput({ userId: undefined });
		};
		// END user search

		return {
			validation,
			DropdownPosition,
			handleUserSearchItemClicked,
			removeUser,
		};
	},
});
